module.exports = __webpack_public_path__ + "static/img/5.0af2414.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/5.png
// module id = R3ms
// module chunks = 0